import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid'
import { PaginationModel } from '@/models/Pagination'
export function TablePagination({ ...props }) {
    const pagination = new PaginationModel((props?.data) ? props.data : {});
    
    const prevPageEventHandler=(event, pagination) => {
        if(props?.prevPageEvent) {
            props?.prevPageEvent(pagination);
        }
        return false;
    }
    const nextPageEventHandler=(event, pagination) => {
        if(pagination.page == 1) return;
        
        if(props?.nextPageEvent) {
            props?.nextPageEvent(pagination);
        }
        
        return false;
    }
    
    if(!(props?.data)) {
        return (<></>);
        
    }
    
    
  return (

    <div className={"flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6" +
    (props.className) ? props.classname : ""}>
      <div className="flex flex-1 justify-between sm:hidden">
        <a
          href="#"
          className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Previous
        </a>
        <a
          href="#"
          className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Next
        </a>
      </div>
      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <div>
          <p className="text-sm text-gray-700">
            <span className="font-medium">{pagination?.from}</span> tot <span className="font-medium">{pagination.to}</span> van de{' '}
            <span className="font-medium">{pagination?.total}</span> resultaten
          </p>
        </div>
        <div>
          <nav aria-label="Pagination" className="isolate inline-flex -space-x-px rounded-md shadow-sm">
            <a
              href="#" onClick={(event) => prevPageEventHandler(event, pagination)}
              className="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
            >
              <span className="sr-only">Previous</span>
              <ChevronLeftIcon aria-hidden="true" className="h-5 w-5" />
            </a>
            <a
              href="#" onClick={(event) => nextPageEventHandler(event, pagination)}
              className="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
            >
              <span className="sr-only">Next</span>
              <ChevronRightIcon aria-hidden="true" className="h-5 w-5" />
            </a>
          </nav>
        </div>
      </div>
    </div>

    )    
}
